
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignments.no_assignments_search";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/bitrock/ruby27stack/apps/canvaslms/htdocs/ui/features/assignment-index/jst/NoAssignmentsSearch';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div>\n  <div class=\"ig-header\">\n    <h2 class=\"ig-header-title\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.no_assignments_search")
  },data:data},helper ? helper.call(depth0, "aria_assignments", "Assignments", options) : helperMissing.call(depth0, "t", "aria_assignments", "Assignments", options)))
    + "\">\n      <i class=\"icon-mini-arrow-down\"></i>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.no_assignments_search")
  },data:data},helper ? helper.call(depth0, "assignments", "Assignments", options) : helperMissing.call(depth0, "t", "assignments", "Assignments", options)))
    + "\n    </h2>\n  </div>\n  <ul class=\"ig-list\">\n    <li>\n      <div class=\"ig-row ig-row-empty\">\n        <div class=\"ig-empty-msg\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("assignments.no_assignments_search")
  },data:data},helper ? helper.call(depth0, "no_assignments_found", "No assignments found", options) : helperMissing.call(depth0, "t", "no_assignments_found", "No assignments found", options)))
    + "\n        </div>\n      </div>\n    </li>\n  </ul>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  